import * as _ from 'underscore';
import * as $ from 'jquery';

import { ColorBoxField } from '../../../../_common/platform/ts/ColorBoxField';
import SelectField from '../../../../_common/platform/ts/SelectField';
import BooleanField from '../../../../_common/platform/ts/BooleanField';
import NumberField from '../../../../_common/platform/ts/NumberField';
import StringField from '../../../../_common/platform/ts/StringField';

import * as validators from '../components/Validators';
import { validators as ValidatorPlatform } from '../../../../_common/platform/ts/validators';
import * as Config from '../config';

// Theme dispatcher module
import * as appTheme from '../../../../_common/platform/ts/appTheme';

// Any dependency themes, which should be initialized before this one
import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';

import { ThemePreview } from './ThemePreview';

// CSS template for the widget
const template = require('!!raw-loader!pdc-widget-treelist/src/mainTheme.template.css').default;

// A hack, to make sure that TS compiler will include this module as dependency in generated AMD
template;

// This array, which saves all glob objects, on which theme was initialized
// It's used to make sure that `init` is launched only once for each glob.
// Here, it's possible that platform will run init for widgetTheme more than 1 time.
var _init = [];

export function init(glob) {
    // If init already invoked – halt
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    // Init parent theme
    widgetTheme(glob);

    const sectionEditingId = Config.themeId + '-Editing'; //LL: 14.03.24  TL
    //LL: 14.11.24 rem const groupEditingDialogId = sectionEditingId + '-DialogOptions'; //LL: 15.03.24  TL
    const groupEditingOptionsId = sectionEditingId + '-Options'; //LL: 18.03.24  TL

    const groupGroupNodesId = 'treelist-group-nodes'; //LL: 21.03.24  TL

    // Register section, which will be displayed on the left of theme edit component
    appTheme.registerSections([
        {
            id: Config.themeId, //'widget-treelist',
            name: 'TreeList',
            parent: 'widget',
            preview: ThemePreview,
            previewClassName: 'preview-widget preview-widget-treelist',
            themeType: 'Widget TreeList',
            visibility: ['application', 'workspace', 'pdc-widget-treelist'] // , 'pdc-helpdesk-issue-treelist']
        },
        //LL: 14.03.24  TL
        {
            id: sectionEditingId,
            name: 'Editing',
            parent: Config.themeId,
            themeType: 'Widget TreeList',
            //hiddenOptions: { hiddenFunction: isHidden_not_XY },
            //dontSortChildren: true, //LL: 26.05.20
            visibility: ['application', 'workspace', 'pdc-widget-treelist']
        }
    ]);

    // gray-base    = main fore coloe
    // surface-bg   = main background

    appTheme.registerGroups([
        {
            id: groupGroupNodesId,
            name: 'Grouping Nodes',
            section: 'widget-treelist'
        },

        {
            id: 'treelist-panel-header',
            name: 'Column Headers',
            section: 'widget-treelist'
        },
        {
            id: 'treelist-panel-rows',
            name: 'Rows',
            section: 'widget-treelist'
        },
        //LL: 19.03.24 TL rem
        //{
        //    id: 'treelist-group-row-options',
        //    name: 'Group Rows',
        //    section: 'widget-treelist'
        //},

        {
            id: 'treelist-lines-options',
            name: 'Grid Lines',
            section: 'widget-treelist'
        },
        {
            id: 'treelist-group-options',
            name: 'Others',
            section: 'widget-treelist'
        },
        {
            id: 'treelist-group-search',
            name: 'Search Panel',
            section: 'widget-treelist'
        },
        {
            id: 'treelist-group-column-chooser',
            name: 'Column Chooser Options',
            //LL: 03.03.21: rem, now my ColPicker:
            //explanation: 'In "Drag and Drop" mode, move column headers to and from the Column Chooser by drag and drop.
            //In "Select" mode, select column headers in the Column Chooser using check boxes.'.
            section: 'widget-treelist'
        },
        {
            id: 'treelist-group-storeGridLayout',
            name: 'Store Grid Layout Options',
            section: 'widget-treelist'
        },
        {
            id: 'treelist-group-dataRetrieving',
            name: 'Data Retrieving',
            section: 'widget-treelist'
        },
        {
            id: 'treelist-group-native-scrollbar',
            name: 'Scrollbar',
            section: 'widget-treelist'
        },

        //LL: 14.11.24 rem
        // //LL: 15.03.24  TL  // Editing // as in DataEdit
        // {
        //     id: groupEditingDialogId,
        //     name: 'Popup Dialog Options',
        //     section: sectionEditingId
        // },
        //LL: 18.03.24  TL  // Editing // as in DataEdit
        {
            id: groupEditingOptionsId,
            name: 'Editing Options',
            explanation: 'To use Editing, Data Grouping Attribute in "Data" Tab must be defined (in "Tree Config" column use checkbox and option "Attribute defines the Data grouping")',
            section: sectionEditingId
        }
    ]);

    // Register theme variables
    appTheme.registerVars([
        {
            id: Config.themeFields.nodes_removeEmptyGroupNodes,
            param: new BooleanField(glob, 'Remove Empty Group Nodes (when NOT Load On Demand)', [], false),
            section: 'widget-treelist',
            group: groupGroupNodesId
        },
        {
            id: Config.themeFields.nodes_hideLowLevelWithoutParent,
            param: new BooleanField(glob, 'Hide Low Level Nodes without Parent (when NOT Load On Demand)', [], true),
            section: 'widget-treelist',
            group: groupGroupNodesId
        },
        {
            id: Config.themeFields.require_dataCount_role,
            param: new BooleanField(glob, 'Require "dataCount" Role (when Load On Demand)', [], false),
            section: 'widget-treelist',
            group: groupGroupNodesId
        },
        {
            id: Config.themeFields.nodes_groupRowsColoring,
            param: new SelectField(glob, 'Group Rows Coloring', [], 'left1', {
                values: ['left1', 'all'], //LL: maybe plus "left2"
                display: ['left column', 'whole row']
            }),
            section: 'widget-treelist',
            group: groupGroupNodesId
        },
        {
            id: Config.themeFields.groupingOrder_show_inToolbar,
            param: new BooleanField(glob, 'Show "Grouping Order" Control in Grid Toolbar', [], true),
            section: 'widget-treelist',
            group: groupGroupNodesId
        },
        {
            id: Config.themeFields.nodes_groupRows_separatorInUnion,
            param: new StringField(glob, 
                'Separator of values in "union" Tree Aggregation', 
                [
                    ValidatorPlatform.string.notEmpty,
                    //ValidatorPlatform.string.notAllBlanks,
                    ValidatorPlatform.string.length(1, 6)
                ], 
                ';',
                {
                    allowNull: false,
                    //maxLength: 6,
                    applyOnEnter: true
                }
            ),
            section: 'widget-treelist',
            group: groupGroupNodesId
        },
        {
            id: Config.themeFields.config_highlight_tree_columns,
            param: new ColorBoxField(
                glob,
                'Highlight "Tree" columns in config with background color:',
                [],
                '#f8f8f8',
                { hideTransparency: false }
            ),
            section: 'widget-treelist',
            group: groupGroupNodesId
        },

        {
            id: Config.themeFields.multiRowOperations,
            param: new BooleanField(glob, 'Multi Row Operations (not implemented)', [], false),
            section: sectionEditingId,
            group: groupEditingOptionsId
        },
        {
            id: Config.themeFields.useApplyButton,
            param: new BooleanField(glob, 'Use Apply Button (not implemented)', [], false),
            section: sectionEditingId,
            group: groupEditingOptionsId
        },
        {
            id: Config.themeFields.edit_DataEditDialogID_Inserting,
            param: new StringField(glob, 'Data Edit Dialog ID for Inserting', [], null, {
                allowNull: true
            }),
            section: sectionEditingId,
            group: groupEditingOptionsId
        },
        {
            id: Config.themeFields.edit_DataEditDialogID_Updating,
            param: new StringField(glob, 'Data Edit Dialog ID for Updating', [], null, {
                allowNull: true
            }),
            section: sectionEditingId,
            group: groupEditingOptionsId
        },
        {
            id: Config.themeFields.edit_allowDeleting,
            param: new BooleanField(glob, 'Allow Deleting', [], false),
            section: sectionEditingId,
            group: groupEditingOptionsId
        },

        {
            id: Config.themeFields.edit_buttonsPosition,
            param: new SelectField(glob, 'Edit Buttons Column Position', [], 'right', {
                values: ['left', 'right'],
                display: ['left', 'right']
            }),
            section: sectionEditingId,
            group: groupEditingOptionsId
        },

        // Header ============================================
        {
            id: 'widget-treelist-show-column-headers',
            param: new BooleanField(glob, 'Show Column Headers', [], true),
            section: 'widget-treelist',
            group: 'treelist-panel-header'
        },
        {
            id: 'widget-treelist-hd-color',
            param: new ColorBoxField(
                glob,
                'Header Font Color',
                [],
                function (theme) {
                    return theme['on-secondary'];
                },
                { hideTransparency: true }
            ),
            section: 'widget-treelist',
            deps: ['on-secondary'],
            group: 'treelist-panel-header'
        },
        {
            id: 'widget-treelist-hdbg-color',
            param: new ColorBoxField(
                glob,
                'Header Background Color',
                [],
                function (theme) {
                    return theme['secondary-bg'];
                },
                { hideTransparency: false }
            ),
            section: 'widget-treelist',
            deps: ['secondary-bg'],
            group: 'treelist-panel-header'
        },
        //LL: 11.01.22:
        {
            id: 'widget-treelist-header-alignment',
            param: new SelectField(glob, 'Column Header Alignment', [], 'default', {
                values: ['default', 'left', 'center', 'right'],
                display: ['default', 'left', 'center', 'right']
            }),
            section: 'widget-treelist',
            group: 'treelist-panel-header'
        },

        // ROWS panel: ==================================================
        {
            id: 'widget-treelist-row-color',
            param: new ColorBoxField(
                glob,
                'Row Font Color',
                [],
                function (theme) {
                    return theme['gray-base'];
                },
                { hideTransparency: true }
            ),
            section: 'widget-treelist',
            deps: ['gray-base'],
            group: 'treelist-panel-rows'
        },
        {
            id: 'widget-treelist-rowbg-color',
            param: new ColorBoxField(
                glob,
                'Row Background Color',
                [],
                function (theme) {
                    return theme['surface-bg'];
                },
                { hideTransparency: false }
            ),
            section: 'widget-treelist',
            deps: ['surface-bg'],
            group: 'treelist-panel-rows'
        },
        {
            id: Config.themeFields.rowHighligtingColor,
            param: new ColorBoxField(glob, 'Row Highligting Color', [], '#0D47A1', { hideTransparency: true }),
            section: 'widget-treelist',
            deps: ['gray-base'],
            group: 'treelist-panel-rows'
        },
        {
            id: 'widget-treelist-row-alternation',
            param: new BooleanField(glob, 'Row Alternation', [], true),
            section: 'widget-treelist',
            group: 'treelist-panel-rows'
        },
        // {
        //     id: 'widget-treelist-row-selection',
        //     param: new BooleanField(glob, 'Row Selection', [], true),
        //     section: 'widget-treelist',
        //     group: 'treelist-panel-rows'
        // },
        {
            id: 'widget-treelist-hover-enabled',
            param: new BooleanField(glob, 'Row Hover', [], true),
            section: 'widget-treelist',
            group: 'treelist-panel-rows'
        },
        {
            id: 'widget-treelist-padding-top',
            param: new StringField(
                glob,
                'Padding top (auto|length specified in px, pt, cm, etc | %)',
                [validators.length.pixel_percent],
                '5px'
            ),
            section: 'widget-treelist',
            group: 'treelist-panel-rows'
        },
        {
            id: 'widget-treelist-padding-bottom',
            param: new StringField(
                glob,
                'Padding bottom (auto|length specified in px, pt, cm, etc | %)',
                [validators.length.pixel_percent],
                '5px'
            ),
            section: 'widget-treelist',
            group: 'treelist-panel-rows'
        },

        //LL: 19.03.24 TL rem
        //{
        //    id: 'widget-treelist-rowsum-color',
        //    param: new ColorBoxField(
        //        glob,
        //        'Summary Background Color',
        //        [],
        //        function (theme) {
        //            return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.92).hexString();
        //        },
        //        { hideTransparency: true }
        //    ),
        //    section: 'widget-treelist',
        //    deps: ['gray-base', 'surface-bg'],
        //    group: 'treelist-panel-rows'
        //},

        // Panel "Group Rows" ==========================================
        //LL: 19.03.24 TL rem
        //{
        //    id: 'widget-treelist-grouprow-color',
        //    param: new ColorBoxField(
        //        glob,
        //        'Group Row Font Color',
        //        [],
        //        function (theme) {
        //            return theme['gray-base'];
        //        },
        //        { hideTransparency: true }
        //    ),
        //    section: 'widget-treelist',
        //    deps: ['gray-base'],
        //    group: 'treelist-group-row-options'
        //},
        //{
        //    id: 'widget-treelist-grouprow-bg-color',
        //    param: new ColorBoxField(
        //        glob,
        //        'Group Row Background',
        //        [],
        //        function (theme) {
        //            return Color(theme['secondary-bg']).hexString();
        //        },
        //        // function (theme) {
        //        //     return theme['surface-bg'];
        //        // },
        //        { hideTransparency: false }
        //    ),
        //    section: 'widget-treelist',
        //    deps: ['secondary-bg'],
        //    group: 'treelist-group-row-options'
        //},
        //{
        //    id: 'widget-treelist-grouprow-top-border',
        //    param: new NumberField(
        //        glob,
        //        'Width of top border (0-8)',
        //        [ValidatorPlatform.number.range(0, 8), ValidatorPlatform.number.integer],
        //        1
        //    ),
        //    section: 'widget-treelist',
        //    group: 'treelist-group-row-options'
        //},
        //{
        //    id: 'widget-treelist-grouprow-bottom-border',
        //    param: new NumberField(
        //        glob,
        //        'Width of bottom border (0-8)',
        //        [ValidatorPlatform.number.range(0, 8), ValidatorPlatform.number.integer],
        //        1
        //    ),
        //    section: 'widget-treelist',
        //    group: 'treelist-group-row-options'
        //},
        //{
        //    id: 'widget-treelist-grouprow-border-color',
        //    param: new ColorBoxField(
        //        glob,
        //        'Border Color',
        //        [],
        //        function (theme) {
        //            return theme['gray-base'];
        //        },
        //        { hideTransparency: false }
        //    ),
        //    section: 'widget-treelist',
        //    group: 'treelist-group-row-options'
        //},
        //
        ////LL: 27.10.21
        //{
        //    id: 'widget-treelist-grouprow-hide-buttons',
        //    param: new BooleanField(
        //        glob,
        //        'Hide "expand/collapse" buttons (expand/collapse by row click)',
        //        [],
        //        false),
        //    section: 'widget-treelist',
        //    group: 'treelist-group-row-options'
        //},

        // Panel "Grid Lines" ==========================================
        {
            id: 'widget-treelist-show-row-lines',
            param: new BooleanField(glob, 'Show Row Lines', [], true),
            section: 'widget-treelist',
            group: 'treelist-lines-options'
        },
        {
            id: 'widget-treelist-show-column-lines',
            param: new BooleanField(glob, 'Show Column Lines', [], true),
            section: 'widget-treelist',
            group: 'treelist-lines-options'
        },

        {
            id: 'widget-treelist-lines-color',
            param: new ColorBoxField(glob, 'Vertical & Horizontal Lines Color', [], '#DDDDDD', {
                hideTransparency: true
            }),
            section: 'widget-treelist',
            group: 'treelist-lines-options'
        },

        // Panel "Other Options" ==========================================
        {
            id: Config.themeFields.useRowMode,
            param: new BooleanField(glob, 'Use Row Mode for Click-To-Filter', [], true),
            section: 'widget-treelist',
            group: 'treelist-group-options'
        },
        {
            id: Config.themeFields.allowGrouping,
            param: new BooleanField(glob, 'Allow Grouping (not used with Endless Scrolling)', [], false),
            section: 'widget-treelist',
            group: 'treelist-group-options'
        },
        {
            id: Config.themeFields.showToolbar,
            param: new BooleanField(glob, 'Show Grid Toolbar', [], true),
            section: 'widget-treelist',
            group: 'treelist-group-options'
        },
        {
            id: Config.themeFields.showFilterRow,
            param: new BooleanField(glob, 'Show Filter Row', [], false),
            section: 'widget-treelist',
            group: 'treelist-group-options'
        },
        {
            id: Config.themeFields.showCollapseExpandButton,
            param: new BooleanField(glob, 'Show "Collapse All"/"Expand All" Button', [], false),
            section: 'widget-treelist',
            group: 'treelist-group-options'
        },
        {
            id: Config.themeFields.showCollapseGroupingsByDefault,
            param: new BooleanField(glob, 'Collapse Groupings By Default', [], false),
            section: 'widget-treelist',
            group: 'treelist-group-options'
        },
        {
            id: 'widget-treelist-alignment',
            param: new SelectField(glob, 'Column Data Alignment', [], 'default', {
                values: ['default', 'left', 'center', 'right'],
                display: ['default', 'left', 'center', 'right']
            }),
            section: 'widget-treelist',
            group: 'treelist-group-options'
        },
        {
            id: 'widget-treelist-wrap-enabled',
            param: new BooleanField(glob, 'Use Word Wrap', [], false),
            section: 'widget-treelist',
            group: 'treelist-group-options'
        },
        {
            id: 'widget-treelist-column-fix',
            param: new BooleanField(glob, 'Allow Column Fixing', [], true),
            section: 'widget-treelist',
            group: 'treelist-group-options'
        },
        {
            id: 'widget-treelist-column-resize',
            param: new BooleanField(glob, 'Allow Column Resizing', [], true),
            section: 'widget-treelist',
            group: 'treelist-group-options'
        },
        {
            id: 'widget-treelist-column-resizing-mode',
            param: new SelectField(glob, 'Column Resizing Mode', [], 'nextColumn', {
                values: ['nextColumn', 'widget'],
                display: [
                    'The width of the next column changes',
                    'The width of the Grid changes (ignored if width of any column is in percents)'
                ],
                tooltips: [
                    'The width of the next column changes',
                    'The width of the Grid changes (ignored if width of any column is in percents)'
                ]
            }),
            section: 'widget-treelist',
            group: 'treelist-group-options'
        },
        {
            id: 'widget-treelist-min-column-width',
            param: new NumberField(
                glob,
                'Min Column Width (px)',
                [
                    ValidatorPlatform.number.range(0, 50),
                    ValidatorPlatform.number.not_negative,
                    ValidatorPlatform.number.integer
                ],
                null,
                {
                    allowNull: true,
                    applyOnEnter: true
                }
            ),
            section: 'widget-treelist',
            group: 'treelist-group-options'
        },
        //The whole background color:
        {
            id: 'widget-treelist-bg-color',
            param: new ColorBoxField(
                glob,
                'Background Color',
                [],
                function (theme) {
                    return theme['surface-bg'] || '#FFFFFF';
                },
                {
                    hideTransparency: false
                }
            ),
            section: 'widget-treelist',
            deps: ['surface-bg'],
            group: 'treelist-group-options'
        },

        //LL: 20.10.20: Column Chooser

        //LL: 02.02.21: " Button in Grid Toolbar"
        {
            id: 'widget-treelist-column-chooser-show',
            param: new BooleanField(glob, 'Show Column Chooser Button in Grid Toolbar', [], false),
            section: 'widget-treelist',
            group: 'treelist-group-column-chooser'
        },

        //LL: 08.03.21:
        {
            id: 'widget-treelist-reset-layout-button-show',
            param: new BooleanField(glob, 'Show Reset Layout Button in Grid Toolbar', [], false),
            section: 'widget-treelist',
            group: 'treelist-group-column-chooser'
        },

        //LL: 03.03.21: hidden, now my ColPicker:
        {
            id: 'widget-treelist-column-chooser-mode',
            hidden: true,
            param: new SelectField(glob, 'Column Chooser Mode', [], 'dragAndDrop', {
                values: ['dragAndDrop', 'select'],
                display: ['Drag and Drop', 'Select']
            }),
            section: 'widget-treelist',
            group: 'treelist-group-column-chooser'
        },

        //LL: 03.03.21: hidden, now my ColPicker:
        {
            id: 'widget-treelist-column-chooser-width',
            hidden: true,
            param: new NumberField(
                glob,
                'Column Chooser Panel Width (150-800)',
                [
                    ValidatorPlatform.number.range(150, 800),
                    ValidatorPlatform.number.positive,
                    ValidatorPlatform.number.integer
                ],
                250, //LL:  DevExpr default
                {
                    //min: 150,
                    //max: 800,
                    applyOnEnter: true
                }
            ),
            section: 'widget-treelist',
            group: 'treelist-group-column-chooser'
        },
        //LL: 04.05.21: hidden
        //  Applying of Width to Custom dialogs was removed by Eugene 23.04.21. So, it seems that I have to remove this Option
        //LL: 03.03.21: my ColPicker:
        {
            id: 'widget-treelist-column-picker-width',
            hidden: true,
            param: new NumberField(
                glob,
                'Column Chooser Dialog Width (150-800)',
                [
                    ValidatorPlatform.number.range(150, 800),
                    ValidatorPlatform.number.positive,
                    ValidatorPlatform.number.integer
                ],
                300,
                {
                    //min: 150,
                    //max: 800,
                    applyOnEnter: true
                }
            ),
            section: 'widget-treelist',
            group: 'treelist-group-column-chooser'
        },

        //LL: 03.03.21: hidden, now my ColPicker:
        {
            id: 'widget-treelist-column-chooser-height',
            hidden: true,
            param: new NumberField(
                glob,
                'Column Chooser Panel Height (130-800)',
                [
                    ValidatorPlatform.number.range(130, 800),
                    ValidatorPlatform.number.positive,
                    ValidatorPlatform.number.integer
                ],
                260, //LL:  DevExpr default
                {
                    //min: 130,
                    //max: 800,
                    applyOnEnter: true
                }
            ),
            section: 'widget-treelist',
            group: 'treelist-group-column-chooser'
        },

        {
            id: 'widget-treelist-show-search',
            param: new BooleanField(glob, 'Show Search Panel', [], false),
            section: 'widget-treelist',
            group: 'treelist-group-search'
        },
        {
            id: 'widget-treelist-search-panel-width',
            param: new NumberField(
                glob,
                'Search Panel Width',
                [ValidatorPlatform.number.range(50, 300), ValidatorPlatform.number.integer],
                120,
                {
                    applyOnEnter: true
                }
            ),
            section: 'widget-treelist',
            group: 'treelist-group-search'
        },

        //LL: 19.04.21: Leo thinks that no need to reset after Config:
        ////LL: 25.12.20:
        //{
        //    id: 'widget-treelist-storetreelistLayout-resetLayoutAfterConfigurationChange',
        //    param: new BooleanField(glob, 'Reset Layout after Saving of Changed Configuration', [], true),
        //    section: 'widget-treelist',
        //    group: 'treelist-group-storetreelistLayout'
        //},

        {
            id: 'widget-treelist-dataRetrieving-specialMainGroupHandling',
            param: new BooleanField(glob, 'Special Main Group Handling', [], false),
            section: 'widget-treelist',
            group: 'treelist-group-dataRetrieving'
        },

        {
            id: 'widget-treelist-native-scrollbar',
            param: new BooleanField(glob, 'Native scrollbar', [], false),
            section: 'widget-treelist',
            group: 'treelist-group-native-scrollbar'
        }
    ]);

    // Register templates
    appTheme.registerTemplate(template, ['pdc-widget-treelist']);

    appTheme.registerPreRender(function (input) {
        var vars = {};

        //color.luminosity();  //ex: 0.412 (0 is black, 1 is white.)
        // The [WCAG luminosity](http://www.w3.org/TR/WCAG20/#relativeluminancedef) of the color. 0 is black, 1 is white.

        //var colorArr = Color(input['widget-treelist-rowbg-color']).rgbArray();
        //vars['widget-treelist-rowbg-color-r'] = colorArr[0];
        //vars['widget-treelist-rowbg-color-g'] = colorArr[1];
        //vars['widget-treelist-rowbg-color-b'] = colorArr[2];
        //vars['widget-treelist-rowbg-color-op'] = 1.0-(Color(input['widget-treelist-rowbg-color']).luminosity()*0.8);
        //
        //var colorAltArr = Color(input['widget-treelist-rowbgalt-color']).rgbArray();
        //vars['widget-treelist-rowbgalt-color-r'] = colorAltArr[0];
        //vars['widget-treelist-rowbgalt-color-g'] = colorAltArr[1];
        //vars['widget-treelist-rowbgalt-color-b'] = colorAltArr[2];
        //vars['widget-treelist-rowbgalt-color-op'] = 1.0-(Color(input['widget-treelist-rowbgalt-color']).luminosity()*0.8);

        return _.extend(input, vars);
    });
    _init.push(glob);
}

